import { Component, inject, Input, OnInit } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { ROUTES_CONFIG } from "src/config/routes.config";
import { ApplicationService } from "src/services/application.service";
import { DialogService } from "../../../dialog/dialog.service";
import {
  ThumbnailEnlargeDialogComponent,
  ThumbnailEnlargeDialogData,
} from "../../../dialog/impl/thumbnail-enlarge-dialog/thumbnail-enlarge-dialog.component";
import { PrefixComponent } from "../../prefix.component";
import { LinkData } from "../../templates/template-link/template-link.component";

@Component({
  selector: "app-prefix-lni",
  imports: [MatIconModule],
  templateUrl: "./prefix-lni.component.html",
  styleUrl: "./prefix-lni.component.less",
})
export class PrefixLniComponent extends PrefixComponent<unknown> implements OnInit {
  @Input()
  public imageLinks: LinkData[];

  @Input()
  public size: number;

  public image_small: string | null;
  public image_large: string | null;

  private application: ApplicationService;
  private dialog: DialogService;

  public constructor() {
    super();
    this.imageLinks = [];
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["lni"];
    this.application = inject(ApplicationService);
    this.image_small = null;
    this.image_large = null;
    this.dialog = inject(DialogService);
    this.size = 100;
  }

  public ngOnInit(): void {
    super.ngOnInit();
    if (this.imageLinks.length) {
      const imgLink = this.imageLinks[0];
      this.image_small = this.constructImageLink(imgLink, this.size, this.size);
      this.image_large = this.constructImageLink(imgLink, null, null);
    }
  }

  public constructImageLink(link: LinkData, width: number | null, height: number | null): string {
    const params = new URLSearchParams();
    params.append("ID", link.link);
    params.append("tabindex", this.application.index || "");
    if (width !== null) params.append("gtpWidth", width.toString());
    if (height !== null) params.append("gtpHeight", height.toString());
    return `${ROUTES_CONFIG.getImageURL}?${params.toString()}`;
  }

  public onImageClick(): void {
    if (this.image_large)
      this.dialog.open<ThumbnailEnlargeDialogData>(ThumbnailEnlargeDialogComponent, {
        source: this.image_large,
        title: { label: this.imageLinks[0].value },
      });
  }
}
